import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const UserMenuSectionIconDefaultBox = styled.div`
    /* .user-menu-box-icon */
    background-image: url("${({theme}) => theme.images.spriteSheet.toString()}");
    background-repeat: no-repeat;
    width: 51px;
    height: 51px;
    margin-top: -50px;
`;

/* 777 */
const UserMenuSectionIconCasino777Box = styled(UserMenuSectionIconDefaultBox)`
    /* .user-menu-box-icon */
    width: 50px;
    height: 50px;
    z-index: 1;
`;

export const UserMenuSectionIconBox = styledByTheme(UserMenuSectionIconDefaultBox)
    .forCasino777(UserMenuSectionIconCasino777Box)
    .apply();
